export default {
  title: 'Mobilní aplikace eVlastníci',
  text: 'Hlasování, zprávy i dokumenty máte pohodlněji v mobilní aplikaci eVlastníci.',
  download: {
    ios: 'Stáhnout pro iPhone',
    android: 'Stáhnout pro Android',
  },
  close: 'Zavřít',
};
